
import {Component, Mixins, Prop} from "vue-property-decorator";
import DatabasePicker from "@/components/pickers/DatabasePicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";

@Component({
  components: {DatabasePicker},
})
export default class FaizTuruPicker extends Mixins(SimpleInputMixin) {
  @Prop() returnId!: boolean;
  @Prop() disabled!: boolean;
  @Prop({default: false}) isUpdate!: boolean;
  @Prop() action!: string;
  @Prop({default: "Faiz Türü"}) label!: string;
  @Prop() defaultId !: number;
  @Prop() selectedOption: any;
  @Prop() rules !: string;

  // The saved choice belongs to the claim being edited. User selection changes
  // must not remove it from the menu before the edit is saved or cancelled.
  private savedOptionId: number | null = this.defaultId == null ? null : this.defaultId;
  private savedOption: FaizTuruEntity | null =
      this.selectedOption?.takip_id && this.selectedOption.id == this.defaultId
          ? this.selectedOption : null;

  // SimpleInputMixin'den gelen metod
  declare input: () => void;

  get getDefaultId() {
    return this.defaultId;
  }

  filter(items: Array<FaizTuruEntity>) {
    const visible = items.filter(item => !item.takip_id ||
        (this.savedOptionId != null && item.id == this.savedOptionId));
    if (this.savedOption && !visible.some(item => item.id == this.savedOptionId)) {
      return [...visible, this.savedOption];
    }
    return visible;
  }

  mounted() {
    this.input();
  }
}
